import { QuestionTypes } from '../core/enums';
import { Question } from './QuestionModels';

export default interface SurveyAnswer {
	clientSurveyAnswerId?: number;
	questionUniqueName: string;
	answer: string;
	score?: number;
	clientSurveyId?: number;
	surveyAnswerUniqueId?: string;
}

export const createEmptySurveyAnswer = (questionSpec: Question): SurveyAnswer => {
	const defaultSliderValue = 3; // Must have a default value, and 3 is almost the middle in current project.
	return {
		questionUniqueName: questionSpec.uniqueName,
		answer:
			questionSpec.type === QuestionTypes.Slider
				? (questionSpec.options.find((x) => x.value === defaultSliderValue)?.label ?? questionSpec.options[0].label)
				: '',
		score: null
	};
};

export interface SurveyUniqueIdWithAnswer {
	surveyUniqueId: string;
	surveyAnswer: SurveyAnswer;
	answerValues: object;
}
